var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./baseService";
class UploadEmployeeService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "upload_employee";
    }
    postEmployeeCsv(csvFile) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(Object.assign({}, this.getDefaultHeaders()), { "Content-Type": "multipart/form-data" });
            const { data } = yield this.api.post(`/${this.controllerName}`, csvFile, { headers });
            return data;
        });
    }
    getUploadEmployeeErrorsCSV(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(Object.assign({}, this.getDefaultHeaders()), { "Content-Type": "text/csv" });
            const { data } = yield this.api.get(`${this.controllerName}/${id}/errors/csv`, {
                headers,
            });
            const DELETE_BLOB_DELAY_MS_TIME = 100;
            const blob = new Blob([data], { type: "data:text/csv;charset=utf-8," });
            const blobURL = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.download = `uploadEmployeeErrors_${id}.csv`;
            anchor.href = blobURL;
            anchor.dataset.downloadurl = [
                "text/csv",
                anchor.download,
                anchor.href,
            ].join(":");
            anchor.click();
            setTimeout(() => {
                URL.revokeObjectURL(blobURL);
            }, DELETE_BLOB_DELAY_MS_TIME);
            return Promise.resolve({
                data: {},
            });
        });
    }
}
export const uploadEmployeeService = new UploadEmployeeService();
//# sourceMappingURL=uploadEmployeeService.js.map